import t from "./extendOwn.js";
import r from "./isMatch.js";
function n(n) {
  return n = t({}, n), function (t) {
    return r(t, n);
  };
}
export { n as default };